import React, { useEffect } from "react";

export default function LegalPage() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const section = document.querySelector(hash);
      if (section) {
        setTimeout(() => section.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }
  }, []);

  const containerStyle = {
    minHeight: "100vh",
    backgroundColor: "#18181b",
    color: "white",
    padding: "3rem 1.5rem",
    maxWidth: "700px",
    margin: "0 auto",
  };

  const headingStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    textAlign: "center",
  };

  const sectionTitle = {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#00b894",
    marginBottom: "0.5rem",
  };

  const paragraphStyle = {
    fontSize: "0.9rem",
    color: "#ccc",
    lineHeight: "1.6",
    marginBottom: "3rem",
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Legal Information</h1>

      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <a href="#privacy" style={{ margin: "0 1rem", color: "#00b894" }}>Privacy</a>
        <a href="#terms" style={{ margin: "0 1rem", color: "#00b894" }}>Terms</a>
        <a href="#disclaimer" style={{ margin: "0 1rem", color: "#00b894" }}>Disclaimer</a>
      </div>

      <section id="privacy">
        <h2 style={sectionTitle}>Privacy Policy</h2>
        <p style={{ ...paragraphStyle, fontStyle: "italic", marginBottom: "1rem" }}>
          Last Updated: April 2026
        </p>

        <p style={paragraphStyle}>
          At <strong>PaceWerks</strong>, your privacy matters. We don’t collect personal information unless you voluntarily provide it, 
          and we never sell your data. If you submit information via a form (e.g. training preferences, contact form), it’s used solely 
          to provide and improve your experience with our services.
        </p>

        <p style={paragraphStyle}>
          We use basic analytics tools (like Google Analytics) to understand how people use the site, so we can make it better, not to follow you around the internet.
        </p>

        <p style={paragraphStyle}><strong>What we may collect:</strong></p>
        <ul style={{ color: "#ccc", paddingLeft: "1.5rem", marginTop: "-0.5rem" }}>
          <li>Training input data (for plan generation)</li>
          <li>Email or other details you include when you contact us or use site forms</li>
          <li>Anonymous usage data (via cookies or analytics)</li>
        </ul>

        <p style={paragraphStyle}>
          You can request to have any personal information removed at any time by contacting us at{" "}
          <a href="mailto:team@pacewerks.com" style={{ color: "#00b894" }} rel="noopener noreferrer">
            team@pacewerks.com
          </a>.
        </p>
      </section>

      <section id="terms">
        <h2 style={sectionTitle}>Terms of Use</h2>

        <p style={{ ...paragraphStyle, fontStyle: "italic", marginBottom: "1rem" }}>
          Last Updated: April 2026
        </p>

        <p style={paragraphStyle}>
          By using <strong>PaceWerks</strong>, you agree to the following terms and conditions. These terms govern your access to and use 
          of our training tools, calculators, and all related content provided on the site.
        </p>

        <p style={paragraphStyle}><strong>Use of Content:</strong></p>
        <ul style={{ color: "#ccc", paddingLeft: "1.5rem", marginTop: "-0.5rem" }}>
          <li>The information on this site is for general guidance and educational purposes only.</li>
          <li>You may not reproduce, distribute, or resell any content or tools without written permission.</li>
          <li>You are responsible for any actions taken based on the use of training plans or calculators.</li>
        </ul>

        <p style={paragraphStyle}><strong>Modifications & Availability:</strong></p>
        <ul style={{ color: "#ccc", paddingLeft: "1.5rem", marginTop: "-0.5rem" }}>
          <li>We reserve the right to update, modify, or remove any features at any time without notice.</li>
          <li>We strive to keep the site accessible and accurate, but we can’t guarantee uninterrupted service or error-free content.</li>
        </ul>

        <p style={paragraphStyle}>
          Use of this site is at your own risk. By continuing to use it, you acknowledge and accept these terms. If you do not agree, please refrain from using PaceWerks.
        </p>
              </section>

      <section id="disclaimer">
        <h2 style={sectionTitle}>Disclaimer</h2>
        <p style={{ ...paragraphStyle, fontStyle: "italic", marginBottom: "1rem" }}>
          Last Updated: April 2026
        </p>

        <p style={paragraphStyle}>
          The content on <strong>PaceWerks</strong>, including training plans, calculators, and blog posts, is intended for general informational and educational purposes only.
        </p>

        <p style={paragraphStyle}><strong>Not Medical Advice:</strong></p>
        <ul style={{ color: "#ccc", paddingLeft: "1.5rem", marginTop: "-0.5rem" }}>
          <li>PaceWerks does not provide medical advice, diagnosis, or treatment.</li>
          <li>Always consult with a qualified healthcare provider before beginning any fitness program, especially if you have any existing health concerns or conditions.</li>
        </ul>

        <p style={paragraphStyle}><strong>Use at Your Own Risk:</strong></p>
        <ul style={{ color: "#ccc", paddingLeft: "1.5rem", marginTop: "-0.5rem" }}>
          <li>Training recommendations are algorithmically generated and not personalized by a certified coach.</li>
          <li>All users assume full responsibility for their training decisions and physical well-being.</li>
        </ul>

        <p style={paragraphStyle}>
          PaceWerks is not liable for any injuries, losses, or damages that may occur as a result of using this site or following any suggested plans or content.
        </p>

      </section>
    </div>
  );
}
